import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import './style.scss';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import WrapperWidgetIcon, {
  EDIT_ICON,
  DELETE_ICON,
  CLOSE_ICON,
  CHECK_ICON,
  ERROR_ICON,
} from '../../DynamicFormBuilderScreen/Widgets/WrapperWidgetIcon';
import Button from "../../Common/Button";
import Utils from "../../../Services/Utils";
import {checkTriggerCondition, getConditionLabel} from "../../../Services/ConditionalService";

class ModalWorkOrderSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      workOrderTriggersData: {},
    };
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    const { configuration, data } = this.props;
    if (!data) return '';
    const { value, workOrderTriggers } = data;
    const { triggers } = configuration;
    const workOrderTriggersData = {};
   // if (triggers && !Utils.isNull(value)) {
      if (triggers) {
      triggers.map((trigger) => {
        const { triggerType, id } = trigger;
        if (triggerType === '2' && checkTriggerCondition(trigger, configuration, value)) {
          workOrderTriggersData[id] = workOrderTriggers ? (workOrderTriggers[id] || {work_orders: []}) : {work_orders: []};
        }
      });
    }
    this.setState({
      workOrderTriggersData,
    });
  }

  onPressClose = (event) => this.props.onClose(event);

  onCreateWorkOrder = (event, triggerId) => {
    this.props.onCreateWorkOrder(triggerId);
    this.props.onClose(event);
  };

  onEditWorkOrder = (event, triggerId, index) => {
    this.props.onEditWorkOrder(triggerId, index);
    this.props.onClose(event);
  };

  onDeleteWorkOrder = async (event, triggerId, index) => {
    this.props.onDeleteWorkOrder(triggerId, index);
  };

  _getConditionLabel = function (triggerId) {
    const { configuration } = this.props;
    return getConditionLabel(configuration || {}, triggerId);
  }

  render() {

    const { workOrderTriggersData } = this.state;
    const { configuration } = this.props;

    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Work Order List'
        className='Modal_Content'
        overlayClassName='Modal_Overlay'
      >
        <div className='Modal_Content_Container Modal_Content_Container_WorkOrders Center'>
          <h3 className="Align_Left">The answer to the field <span className='Bold'>{configuration.label}</span> fulfils the following Work Order trigger condition/s:</h3>
          <div className="Wrapper_WorkOrders_List">
            { Object.keys(workOrderTriggersData).map((triggerId, indexTrigger) => (
              <div className="Wrapper_TriggerWorkOrders" key={triggerId}>
                <h3 className="Align_Left">
                  <span dangerouslySetInnerHTML={{__html: this._getConditionLabel(triggerId)}}/>
                </h3>
                { workOrderTriggersData[triggerId].work_orders.map((workOrder, index) => (
                  <div className="Wrapper_WorkOrder Table" key={index}>
                    <div className="WorkOrder_Label TableCell">
                      { workOrder.label || workOrder.brief_description }
                      <div className="Inline">
                        <WrapperWidgetIcon
                          display
                          type={workOrder.valid ? CHECK_ICON : ERROR_ICON}
                        />
                      </div>
                    </div>
                    <div className="WorkOrder_Action TableCell">
                      <WrapperWidgetIcon
                        display
                        type={EDIT_ICON}
                        onClick={ (event) => this.onEditWorkOrder(event, triggerId, index) }
                      />
                    </div>
                    <div className="WorkOrder_Action TableCell">
                      <WrapperWidgetIcon
                        display
                        type={DELETE_ICON}
                        onClick={ (event) => this.onDeleteWorkOrder(event, triggerId, index) }
                      />
                    </div>
                  </div>
                  )
                )}
                { workOrderTriggersData[triggerId].work_orders.length < 3 &&
                  <Button className='Button_Small Right'
                    onClick={ (event) => this.onCreateWorkOrder(event, triggerId) }
                  >
                    Create Work Order
                  </Button>
                }
              </div>
              )
            )}
          </div>
          <div className='Modal_Content_Actions Center'>
            <Button className='Button_Small Inline'
              onClick={ this.onPressClose }
            >
              Ok
            </Button>
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <WrapperWidgetIcon
              display
              type={CLOSE_ICON}
              className='Icon-Close'
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalWorkOrderSelector.propTypes = {
  configuration: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  api: LfaContextAPIShape,
  onClose: PropTypes.func.isRequired,
};

export default ModalWorkOrderSelector;
